// @import_dependencies_node Import libraries
import { store } from 'app_storage/redux-storage'
// @end

// @import types
import { IColorsTheme } from 'app_types/colors';
import { IStyleScreen } from 'app_types/userTypes';
// @end

// @import utils
import { getThemeColorss, getThemeColorsFromCSS } from 'app_utils/functions/getTheme';
// @end

// @import services
import Emitter from 'app_services/emitter';
// @end

class ColorsService {

  private storeObject = store

  /**
   * @INFO Cambiar el color del tema o agregar las clases necesarias
   * @param mode
   */
  updateCurrentTheme = (mode: string): string => {
    // Sobrescribir CSS
    let theme = mode.includes('light') ? 'light_theme' : mode.includes('dark') ? 'dark_theme' : ''

    const defaultColors: any = getThemeColorss(mode)

    let styles: string = ''
    const arrayStyles = this.storeObject.getState().auth.user?.data?.styles as IStyleScreen[]
    if (arrayStyles && Array.isArray(arrayStyles)) {
      const idxTheme = arrayStyles.findIndex(item => item.type === theme) as number
      if(idxTheme >= 0){
        styles = styles + arrayStyles[idxTheme].styles
      }
      const idxClasses = arrayStyles.findIndex(item => item.type === 'classes')
      if(idxClasses >= 0) {
        styles = styles + arrayStyles[idxClasses].styles
      }
      // Obtener los colores con JS y enviar por el emitter
      if(styles.length > 3){
        setTimeout(()=>{
          const colors: IColorsTheme = getThemeColorsFromCSS()
          Emitter.emit('change-theme', colors)
        },50)
      }
    } else {
      styles = 'body{'
      for (const key in defaultColors) {
        if (Object.prototype.hasOwnProperty.call(defaultColors, key)) {
          const element = defaultColors[key];
          styles += `--${key}: ${element};`
        }
      }
      styles += '}'
      setTimeout(()=>{
        const colors: IColorsTheme = getThemeColorsFromCSS()
        Emitter.emit('change-theme', colors)
      },50)
    }
    // Retornar los estilos antes de actualizar el hook de useColors
    return styles
  }

}

export default ColorsService
